import React, { useState } from 'react';
import { 
  AcademicCapIcon, 
  BoltIcon, 
  EyeIcon, 
  ExclamationTriangleIcon 
} from '@heroicons/react/24/solid';

const BASE_PATH = "https://gusaguiar.com/assets/premium-gamma-bundle";

const bundleItems = [
  {
    title: "The Full 'Going Gamma' Transmission",
    description: "The complete 4-hour deep dive into the mechanics of the Gamma state.",
    url: "https://dn721301.ca.archive.org/0/items/bashar-going-gamma-2015-11-14_202406/Bashar%20-%20Going%20Gamma%20%282015-11-14%29.ia.mp4",
    Icon: AcademicCapIcon,
    color: "text-sky-400"
  },
  {
    title: "The Complete Fractal System",
    description: "All four 38-minute fractal meditations for total state mastery.",
    url: `${BASE_PATH}/Complete-Fractal-System.mp4`, // Ahora apunta a .mp4
    Icon: BoltIcon,
    color: "text-purple-400"
  },
  {
    title: "The Kaleidoscope Meditation",
    description: "The full 1-hour immersive visual journey.",
    url: `${BASE_PATH}/Joe Dispenza - Kaleidoscope Meditation.mp4`, // Cambiado a .mp4
    Icon: EyeIcon,
    color: "text-pink-400"
  }
];

const PremiumGammaKit = () => {
  const [videoErrors, setVideoErrors] = useState({});

  const handleVideoError = (url) => {
    setVideoErrors(prev => ({ ...prev, [url]: true }));
  };

  // Función auxiliar para determinar el tipo MIME
  const getVideoType = (url) => {
    return url.toLowerCase().endsWith('.webm') ? 'video/webm' : 'video/mp4';
  };

  return (
    <div className="min-h-screen bg-black text-white py-16 px-4">
      <div className="max-w-5xl mx-auto">
        {/* Header */}
        <div className="text-center mb-16">
          <h1 className="text-4xl md:text-5xl font-bold mb-6 bg-clip-text text-transparent bg-gradient-to-r from-yellow-400 to-orange-500">
            Your Premium Gamma Kit
          </h1>
          <p className="text-gray-400 text-lg">Lifetime access to your premium resources.</p>
        </div>

        {/* Video List */}
        <div className="space-y-12">
          {bundleItems.map((item, index) => (
            <div key={index} className="bg-gray-900/40 p-8 rounded-2xl border border-gray-800">
              <div className="flex items-center gap-4 mb-6">
                <item.Icon className={`w-8 h-8 ${item.color}`} />
                <div>
                  <h3 className="text-2xl font-bold">{item.title}</h3>
                  <p className="text-gray-400">{item.description}</p>
                </div>
              </div>

              {videoErrors[item.url] ? (
                <div className="aspect-video w-full rounded-lg border border-red-500/50 bg-red-950/20 flex flex-col items-center justify-center p-8 text-center">
                  <ExclamationTriangleIcon className="w-10 h-10 text-red-400 mb-3" />
                  <p className="text-red-300 mb-4 font-semibold">The video player could not load.</p>
                  <a 
                    href={item.url} 
                    target="_blank" 
                    rel="noopener noreferrer" 
                    className="bg-red-600 px-6 py-2 rounded-lg font-bold hover:bg-red-500 transition-all"
                  >
                    Open Video in New Tab
                  </a>
                </div>
              ) : (
                <div className="aspect-video w-full rounded-lg overflow-hidden border border-gray-700 bg-black">
                  <video 
                    controls 
                    className="w-full h-full" 
                    controlsList="nodownload"
                    onError={() => handleVideoError(item.url)}
                  >
                    <source src={item.url} type={getVideoType(item.url)} />
                    Your browser does not support the video tag.
                  </video>
                </div>
              )}
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};

export default PremiumGammaKit;